<template>
  <div id="automation-creation-distance-timeframe-direction">
    <Input
      class="scs-input"
      heading="Distance"
      placeholder="3"
      type="number"
      :error="errors.distance"
      :initialValue="automation ? automation.trigger.distance : undefined"
      @scs-input="distanceInput"
    />
    <Select
      class="scs-input"
      heading="Timeframe"
      :options="timeframeOptions"
      :formatter="selectFormatter"
      :initial="automation ? automation.trigger.quantity : undefined"
      @input="timeframeChosen"
    />
    <Select
      class="scs-input"
      heading="Direction"
      :options="directionOptions"
      :formatter="selectFormatter"
      :initial="automation ? automation.trigger.direction : undefined"
      @input="directionChosen"
    />
  </div>
</template>
<script>
import Input from "../../../../../../Components/Elements/Input.vue";
import Select from "../../../../../../Components/Elements/Select.vue";
export default {
  data() {
    return {
      timeframeOptions: ["days", "weeks", "months"],
      directionOptions: ["before", "after"],
    };
  },
  computed: {},
  methods: {
    selectFormatter(str) {
      return str[0].toUpperCase() + str.substring(1);
    },
    distanceInput(int) {
      this.$emit("distance-input", int);
    },
    timeframeChosen(value) {
      this.$emit("timeframe-input", value);
    },
    directionChosen(value) {
      this.$emit("direction-input", value);
    },
  },
  created() {},
  components: {
    Input,
    Select,
  },
  emits: ["distance-input", "timeframe-input", "direction-input"],
  props: ["automation", "errors"],
};
</script>
<style scoped>
@media screen {
  #automation-creation-distance-timeframe-direction {
    height: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .scs-input {
    width: 100%;
    margin: 5px;
  }
  @media (min-width: 800px) {
    .scs-input {
      width: 350px;
    }
  }
}
</style>
